module.exports = __webpack_public_path__ + "media/images/login-7a2a11758be0d764fac6dbe860bd430f.svg";